module.exports = __webpack_public_path__ + "images/2023_background3e1cbf1f7ea73353fb13ce93e516683b.gif";